	<!-- actions -->
	<div class="row acciones">
	    <div class="col-md-3" *ngFor="let actions of iconos">
	        <a href={{actions.PAD34URL}} target="blank" class="mb-2 card-body-home">
	            <div class="card text-center">
	                <i class={{actions.PAD34ICO}}></i>
	                <h6>{{actions.PAD34TIT}}</h6>
	            </div>
	        </a>
	    </div>
	</div>